<template>
	<div class="px-4">
		<slot />
	</div>
</template>
